export const dogs = [
  "Saluki (Gazelle Hound)",
  "Affenpinscher",
  "Afghan Hound",
  "Aidi",
  "Airedale Terrier",
  "Akbash Dog",
  "Akita",
  "Alapaha Blue Blood Bulldog",
  "Alaskan Husky",
  "Alaskan Klee Kai",
  "Alaskan Malamute",
  "Alpine Dachsbracke",
  "American Alaskan Spitz",
  "American Bandogge Mastiff",
  "American Black And Tan Coonhound",
  "American Blue Gascon Hound",
  "American Bulldog",
  "American Bully",
  "American Cocker Spaniel",
  "American English Coonhound",
  "American Eskimo",
  "American Eskimo-Miniature",
  "American Eskimo-Toy",
  "American Foxhound",
  "American Hairless Terrier",
  "American Indian",
  "American Leopard Hound",
  "American Mastiff",
  "American Mastiff (Panja)",
  "American Pit Bull",
  "American Pitbull Terrier",
  "American Royal Retriever",
  "American Staffordshire Bull Terrier",
  "American Staffordshire Terrier",
  "American Staghound",
  "American Tundra Shepherd",
  "American Water Spaniel",
  "American White Shepherd",
  "Anatolian",
  "Anatolian/Karabash Shepherd",
  "Anatolian Shepherd",
  "Anatolian Shepherd Mix",
  "Anglo Francais",
  "Appenzeller Sennenhunde",
  "Argentine Dogo",
  "Ariegeois",
  "Aussalier",
  "Aussiedoodle",
  "Australian Blue Heeler",
  "Australian Cattle Dog",
  "Australian Cattle Dog Mix",
  "Australian Dingo",
  "Australian Kelpie",
  "Australian Labradoodle",
  "Australian Red Heeler",
  "Australian Shepherd",
  "Australian Shepherd - Miniature",
  "Australian Shepherd Mix",
  "Australian Shepherd - Toy",
  "Australian Silky Terrier",
  "Australian Stumpy Tail Cattle",
  "Australian Terrier",
  "Austrian Grand Brackes",
  "Azawakh Hound",
  "Balkanski Gonic",
  "Bambino",
  "Bantam Bulldog",
  "Barbet",
  "Basenji",
  "Basset Fauve De Bretagne",
  "Basset Hound",
  "Bassetoodle",
  "Bavarian Mountain Hound",
  "Beabull",
  "Beagle",
  "Beagle Mix",
  "Beaglier",
  "Bearded Collie",
  "Beauceron",
  "Bedlington Terrier",
  "Belgian Laekenois",
  "Belgian Malinois",
  "Belgian Mastiff",
  "Belgian Sheepdog",
  "Belgian Shepherd",
  "Belgian Tervuren",
  "Bergamasco Sheepdog",
  "Berger Des Pyrénées",
  "Berger Picard/Picardy Sheepdog",
  "Bernedoodle",
  "Bernese Mix",
  "Bernese Mountain Dog",
  "Bichon Frise",
  "Black And Tan Coonhound",
  "Blackmouth Cur",
  "Black Russian Terrier",
  "Bloodhound",
  "Blue Heeler",
  "Blue Lacy",
  "Blue Picardy Spaniel",
  "Blue Tick Coonhound",
  "Boerboel",
  "Bolognese",
  "Border Collie",
  "Border Collie Mix",
  "Border Terrier",
  "Borzoi/Russian Wolfhound",
  "Boston Terrier",
  "Boston Terrier Mix",
  "Bouvier Des Flandres",
  "Boxer",
  "Boxer Mix",
  "Boykin Spaniel",
  "Bracco Italiano",
  "Braque D’Avergne",
  "Brazilian Fila",
  "Briard",
  "Brittany Spaniel",
  "Brussels Griffon",
  "Bull Boxer",
  "Bulldog",
  "Bulldog Mix",
  "Bullmastiff",
  "Bull Terrier",
  "Bull Terrier-Miniature",
  "Burmilla",
  "Cairn Terrier Cairn Terrier",
  "Canaan Dog Canaan Dog",
  "Canadian Eskimo/Inuit",
  "Canary Dog",
  "Cane Corso",
  "Cardigan Welsh Corgi",
  "Catahoula Leopard Dog",
  "Caucasian Mountain Dog",
  "Caucasian Ovcharka",
  "Cavachon",
  "Cavalier King Charles Spaniel",
  "Cavalier King Charles Spaniel Mix",
  "Cavapoo",
  "Central Asian Shepherd",
  "Cesky Terrier",
  "Chanille",
  "Chesapeake Bay Retriever",
  "Chihuahua",
  "Chihuahua-Long-Haired",
  "Chihuahua Mix",
  "Chinese Crested",
  "Chinese Crested Powder Puff",
  "Chinese Foo Dog",
  "Chinese Pug",
  "Chinese Shar-Pei Mix",
  "Chinook",
  "Chipom",
  "Chipoo",
  "Chiweenie",
  "Chow Chow",
  "Chow Chow Mix",
  "Cirneco Dell Etna",
  "Clumber Spaniel",
  "Cobber Dog",
  "Cockapoo",
  "Cocker Spaniel",
  "Cocker Spaniel-Miniature",
  "Collie",
  "Collie Mix",
  "Collie-Rough Coated",
  "Collie - Smooth Coated",
  "Coonhound",
  "Coonhound-Black & Tan",
  "Coonhound-Blue Tick",
  "Coonhound-Redbone",
  "Coton De Tulear",
  "Curly-Coated Retriever",
  "Czechoslovakian Wolfdog",
  "Dachshund",
  "Dachshund-Long Haired",
  "Dachshund-Miniature",
  "Dachshund-Miniature Long Haired",
  "Dachshund-Miniature Smooth Haired",
  "Dachshund-Miniature Wire Hair",
  "Dachshund Mix",
  "Dachshund-Wire Haired",
  "Dalmatian",
  "Dalmatian Mix",
  "Dandie Dinmont Terrier",
  "Danish-Swedish Farmdog",
  "Deerhound",
  "Designer / Hybrid",
  "Deutscher Wachtelhund",
  "Dingo/Carolina",
  "Doberman Pinscher",
  "Doberman Pinscher Mix",
  "Dogo Argentino",
  "Dogue De Bordeaux",
  "Dorgie",
  "Dorkie",
  "Double Doodle",
  "Doxipoo",
  "Drentsche Patrijshond",
  "Drever",
  "Dunker/Norwegian Hound",
  "Dutch Sheepdog",
  "Dutch Shepherd",
  "English Bull",
  "English Bulldog",
  "English Cocker Spaniel",
  "English Cream Retriever",
  "English Foxhound",
  "English Mastiff",
  "English Pointer",
  "English Setter",
  "English Shepherd",
  "English Springer Spaniel",
  "English Toy Spaniel",
  "English Toy Terrier",
  "Entlebucher Mountain Dog",
  "Estrela Mountain Dog",
  "Eurasian/Eurasier",
  "Feist",
  "Field Spaniel",
  "Fila Brasileiro/Brazillian Mastiff",
  "Finnish Hound",
  "Finnish Lapphund",
  "Finnish Spitz",
  "Flat-Coated Retriever",
  "Formosan (Taiwanese) Mountain Dog",
  "Fourche Terrier",
  "Fox Terrier",
  "French Bulldog",
  "French Bulldog Mix",
  "Frenchie Pug",
  "French Mastiff",
  "French Spaniel",
  "Frenchton",
  "Ganaraskan",
  "Gascogne Braque Francais",
  "German Longhaired Pointer",
  "German/Mittel Spitz",
  "German Pinscher",
  "German Pointer",
  "German Shepherd",
  "German Shepherd Mix",
  "German Shorthaired Pointer",
  "German Spitz",
  "German Wirehaired Pointer",
  "Giant Schnauzer",
  "Glen Of Imaal Terrier",
  "Goldador",
  "Goldendoodle",
  "Goldendoodle Miniature",
  "Golden Retriever",
  "Golden Retriever Mix",
  "Gordon Setter",
  "Grand Basset Griffon Vendéen",
  "Grand Bleu De Gascogne",
  "Great Dane",
  "Great Dane Mix",
  "Greater Swiss Mountain Dog",
  "Great Pyrenees",
  "Greenland Dog",
  "Greyhound",
  "Groenendael Belgian Shepherd",
  "Hamiltonstovare",
  "Harrier",
  "Havana Silk",
  "Havanese",
  "Havashu",
  "Hovawart",
  "Hungarian Sheepdog",
  "Ibizan Hound",
  "Icelandic Sheepdog",
  "Inca Orchid",
  "Irish Red and White Setter",
  "Irish Setter",
  "Irish Terrier",
  "Irish Water Spaniel",
  "Irish Wolfhound",
  "Italian Bulldogge",
  "Italian Greyhound",
  "Jack Russell Terrier",
  "Jagdterrier",
  "Japanese Chin",
  "Japanese Spaniel",
  "Japanese Spitz",
  "Japanese Terrier",
  "Jindo",
  "Jug",
  "Kai Ken",
  "Karelian Bear Dog",
  "Keeshond",
  "Kelpie",
  "Kerry Beagle",
  "Kerry Blue Terrier",
  "King Shepherd",
  "Kishu Ken",
  "Komondor",
  "Kooikerhondje",
  "Koolie",
  "Korean Jindo",
  "Kromfohrlander",
  "Kuvasz",
  "Kyi-Leo",
  "Labradoodle",
  "Labrador Retriever",
  "Labrador Retriever Black",
  "Labrador Retriever Chocolate",
  "Labrador Retriever Miniature",
  "Labrador Retriever Mix",
  "Labrador Retriever Yellow",
  "Laekenois Belgian Shepherd",
  "Lagotto Romagnolo",
  "Lakeland Terrier",
  "Lancashire Heeler",
  "Landseer",
  "Large Munsterlander",
  "Leonberger",
  "Lhasa Apso",
  " Llewellin Setter",
  "Louisiana Catahoula Hog Dog",
  "Lowchen",
  "Lucas Terrier",
  "Lurcher",
  "Malamute Husky",
  "Malinois Belgian Shepherd",
  "Mal-Shi",
  "Maltese",
  "Maltipoo",
  "Maltipoo",
  "Manchester Terrier - Standard",
  "Maremma",
  "Mastiff",
  "Mastiff Mix",
  "Mexican Hairless",
  "Mexican Hairless-Crested",
  "Mi-Ki",
  "Miniature American Shepherd",
  "Miniature Pinscher",
  "Miniature Poodle",
  "Miniature Schnauzer",
  "Minskin",
  "Mixed Breed",
  "Morkie",
  "Mountain Cur",
  "Mountain Dog Mix",
  "Mountain Feist",
  "Mountain Terrier",
  "Mudi",
  "Münsterländer",
  "Native American Indian",
  "Neapolitan Mastiff",
  "Nebolish Mastiff",
  "Nederlandse Kooikerhondje",
  "Newfoundland",
  "Newfoundland Mix",
  "New Zealand Huntaway",
  "New Zealand Sheepdog",
  " Norfolk Terrier",
  "Norrbottenspets",
  "North American Retriever",
  "North American Shepherd",
  "Northern Inuit",
  "Norwegian Buhund",
  "Norwegian Elkhound",
  "Norwegian/Norsk Lundehund",
  "Norwegian Viking Buhund",
  "Norwich Terrier",
  "Nova Scotia Duck Tolling Retriever",
  "Old Boston Bulldogge",
  "Olde English Bulldog",
  "Old English Mastiff",
  "Old English Sheepdog",
  "Old Victorian Bulldogge",
  "Other - Hybrid Dog",
  "Other - Mixed-breed",
  "Other - Purebred Dog",
  "Otterhound",
  "Papillon",
  "Papillon Mix",
  "Parson Russell Terrier",
  "Patterdale/Fell Terrier",
  "Peekapoo",
  "Pekingese",
  "Pembroke Welsh Corgi",
  "Perro De Presa Canario",
  "Peruvian Hairless",
  "Peruvian Inca Orchid",
  "Petit Basset Griffon Vendeen",
  "Pharaoh Hound",
  "Picardy Spaniel",
  "Pitbull - American Terrier",
  "Pitbull Mix",
  "Pitbull Mix",
  "Plott Hound",
  "Pointer",
  "Polish Lowland Sheepdog",
  "Polish Tatra Sheepdog",
  "Polski Ocharch Nizinny",
  "Pom-A-Nauze",
  "Pomapoo",
  "Pomeranian",
  "Pomeranian Mix",
  "Pomsky",
  "Poochon",
  "Poodle",
  "Poodle Miniature",
  "Poodle Mix",
  "Poodle-Standard",
  "Poodle Standard",
  "Poodle-Teacup",
  "Poodle - Toy",
  "Porkie",
  "Portuguese Podengo",
  "Portuguese Podenjo Pequeno",
  "Portuguese Pointer",
  "Portuguese Sheepdog",
  "Portuguese Water Dog",
  "Prague Ratter",
  "Pudelpointer",
  "Pug",
  "Puggle",
  "Puggle",
  "Pug Mix",
  "Puli",
  "Pumi",
  "Pyrenean Mastiff",
  "Pyrenean Mountain Dog (Great Pyrenees)",
  "Pyrenean Sheepdog",
  "Pyrenean Shepherd",
  "Pyrenees Braque Francais",
  "Queensland Heeler",
  "Rafeiro Do Alentejo",
  "Rat Terrier",
  "Redbone Coonhound",
  "Retriever Mix",
  "Rhodesian Ridgeback",
  "Roman Rottweiler",
  "Rottweiler",
  "Rottweiler Mix",
  "Russell Terrier",
  "Russian Bolonka",
  "Russian Hound",
  "Russian Toy Terrier",
  "Russian Tzvetnaya Bolonka",
  "Russian Wolfhound",
  "Saint Bernard",
  "Saint Bernard Mix",
  "Samoyed",
  "Schapendoes",
  "Schipperke",
  "Schnoodle",
  "Scottish Deerhound",
  "Scottish Terrier",
  "Sealyham Terrier",
  "Segugio Italiano",
  "Shar Pei",
  "Sharpoo",
  "Sheepadoodle",
  "Sheltie",
  "Shetland Sheepdog",
  "Shiba Inu",
  "Shih Tzu",
  "Shih Tzu Mix",
  "Shihpoo",
  "Shikoku",
  "Shiloh Shepherd",
  "Siberian Husky",
  "Siberian Husky Mix",
  "Silken Windhound",
  "Silky Terrier",
  "Silky Terrier Mix",
  "Skye Terrier",
  "Sloughi",
  "Slovensky Cuvac",
  "Small Munsterlander",
  "Smooth Fox Terrier",
  "Snoodle",
  "Soft Coated Wheaten Terrier",
  "South Russian Ovcharka",
  "Spaniel Mix",
  "Spanish Bulldog",
  "Spanish Mastiff",
  "Spanish Water Dog",
  "Spinone Italiano",
  "Spitz",
  "Springer Spaniel",
  "Stabyhoun (Stabij)",
  "Staffordshire Bull Terrier",
  "Standard Schnauzer",
  "St Johns Waterdog",
  "Sussex Spaniel",
  "Swedish Elkhound",
  "Swedish Lapphund",
  "Swedish Vallhund",
  "Telomian",
  "Terrier",
  "Terrier Mix",
  "Terripoo",
  "Tervuren Belgian Shepherd",
  "Texas Blue Lacey",
  "Thai",
  "Thai Ridgeback",
  "Tibetan Mastiff",
  "Tibetan Spaniel",
  "Tibetan Terrier",
  "Tornjak",
  "Tosa",
  "Toy Fox Terrier",
  "Toy Manchester Terrier",
  "Toy Schnauzer",
  "Toy Terrier",
  "Transylvanian Hound",
  "Treeing Cur",
  "Treeing Tennessee Brindle",
  "Treeing Walker Coon Hound",
  "Victorian Bulldog",
  "Vizsla",
  "Vizsla - Wirehaired",
  "Volpino Italiano",
  "Walker Hound",
  "Weimaraner",
  "Welsh Foxhound",
  "Welsh Sheepdog (Welsh Collie)",
  "Springer Spaniel",
  "Welsh Terrier",
  "West Highland White Terrier",
  "Wetterhound",
  "Westmoreland Terrier",
  "Wheaten Terrier",
  "Whippet",
  "White Doberman",
  "Wire Haired Fox Terrier",
  "Wirehaired Pointing Griffon",
  "Wirehaired Vizsla",
  "WorkingKelpie",
  "Woodle",
  "Xoloitzcuintli",
  "Xoloscuintle",
  "Yorkiepoo",
  "Yorkshire Terrier",
  "Yorkshire Terrier Mix",
];
